module.exports = __webpack_public_path__ + "img/hgi-logo-truong-chinh-tri.c54e9997.png";